

import React, { useState, useEffect, useContext } from 'react';
//import RoleService from "../../../../services/SetupService/RoleService/RoleService";
import ContractRateService from "../../controller/ContractRatesController/ContractRateController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { Link } from "react-router-dom";
import CreateContractRate from './CreateContractRate';
import HelpSite from "../../../Common/HelpLink";
function ContractRatesPage() {
    const navigate = useNavigate();
    const [ContractRates, setContractRates] = useState([]);
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [modalInstance, setModalInstance] = useState(null);
    const [currentContractRate, setCurrentContractRate] = useState(null);

    const fetchContractRates = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const contractRatesyData = await ContractRateService.GetAllContractRates(redirectCallback);
            setContractRates(contractRatesyData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    useEffect(() => {
        fetchContractRates();
    }, []);

    useEffect(() => {
        setModalInstance(new window.bootstrap.Modal(document.getElementById('contractRateModal')));
    }, []);

    const handleContractRateClick = () => {
        setCurrentContractRate(null);
        if (modalInstance) {
            modalInstance.show();
        }
    };
    const handleCloseModal = () => {
        if (modalInstance) {
            modalInstance.hide();
        }
    };
    const handleEditClick = (team) => {
        setCurrentContractRate(team); // Set the team to be edited
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleDeleteClick = async (ID) => {
        const confirmed = window.confirm("Are you sure you want to delete this team?");
        if (confirmed) {
            try {
                await ContractRateService.DeleteContractRate(ID);
                fetchContractRates(); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Team:', error);
            }
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>

            <div className="row mb-3">

                <div className="col-sm-3">

                    <Link className='btn btn-primary btn-sm' onClick={handleContractRateClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </Link>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Agreement Rates" Module="26" />
                </div>
            </div>
            <table className="table m-0 table-hover">
                <thead>
                    <tr>

                        <th>Contract Rate</th>
                        <th>Amount</th>
                        <th style={{ "textAlign": "right" }}>Actions</th>
                    </tr>
                </thead><tbody>
                    {ContractRates.map((contract, index) => (

                        <tr key={contract.ID} onClick={() => handleEditClick(contract)}>

                            <td>{contract.ContractRate}</td>
                            <td>{contract.ContractRateAmount}</td>
                            <td style={{ "textAlign": "right" }}>
                                
                                <button className="text-danger mr-2" style={{ "background": "none", "border": "none" }} onClick={() => handleDeleteClick(contract.ID)}>
                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <CreateContractRate contract={currentContractRate} onClose={handleCloseModal} onSuccess={fetchContractRates} />
        </div>
    );
}

export default ContractRatesPage;